import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeviceFactory } from '../../../../device-factory/device-factory';

@Component({
	selector: 'app-daily-battery-fleet-utilization',
	templateUrl: './daily-battery-fleet-utilization.component.html',
	styleUrls: ['./daily-battery-fleet-utilization.component.css']
})
export class DailyBatteryFleetUtilizationComponent {
	@Input() data: any = {};
	@Input() devices: any = {};

	@Input() toDate = new Date();
	@Input() fromDate = new Date(this.toDate.getTime() - 30 * 24 * 60 * 60 * 1000);
	@Input() selectedBatteryVoltage: string = 'all';
	@Input() selectedBatteryCapacity: string = 'all';
	@Input() selectedBatteryVintage: string[] = ['all'];
	@Input() selectedManufacturer: string = 'all';
	@Output() prepareParentFiltersOptions = new EventEmitter<{ batteryVoltagesOptions: any[], batteryCapacitiesOptions: any[], manufacturers: any[] }>();

	chart = {
		firstChartTitle: this.translate.instant('utilization.daily_battery_fleet_utilization'),
		secondChartTitle: this.translate.instant('utilization.daily_percent_battery_fleet_utilization'),
	}
	devicesType = [DeviceFactory.types.battlink, DeviceFactory.types.battlinkII, DeviceFactory.types.lithiumBattlink];

	constructor(
		private translate: TranslateService
	) {}

	prepareParentFiltersOptionsEmitter(event: { batteryVoltagesOptions: any[], batteryCapacitiesOptions: any[], truckManufacturers: any[] }) {
		this.prepareParentFiltersOptions.emit({ ...event, manufacturers: event.truckManufacturers });
	}
}
